import { getSdnAccessToken } from '../lib/utils';
import { MyPointsRankRes, PointsRankRes, RankType } from '../types/task';
import { UserProfile } from '../types/user';
import { http } from './http';

export async function getUserProfile(userId: string): Promise<UserProfile> {
  const token = getSdnAccessToken();
  const res = await fetch(
    `https://beginner.sending.network/_api/client/r0/profile/${encodeURIComponent(
      userId.toLowerCase()
    )}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  if (res.status === 200) {
    return await res.json();
  } else {
    throw await res.text();
  }
}

export async function getSelfPointRank(rankType: RankType): Promise<MyPointsRankRes> {
  return http.get<void, MyPointsRankRes>(`/my_points_rank`, { params: { rank_type: rankType } });
}

export async function getUserPointRank(rankType: RankType): Promise<PointsRankRes> {
  return http.get<void, PointsRankRes>(`/user_points_rank`, {
    params: { rank_type: rankType },
  });
}
